import { render, staticRenderFns } from "./QuotesListView.vue?vue&type=template&id=12fe1d36"
import script from "./QuotesListView.vue?vue&type=script&lang=ts"
export * from "./QuotesListView.vue?vue&type=script&lang=ts"
import style0 from "./QuotesListView.vue?vue&type=style&index=0&id=12fe1d36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports